export default __webpack_public_path__ + "static/media/Greenwich_Bold.cc71ff68.otf";